// extracted by css-extract-rspack-plugin
export default {"sub-sources-container":"SourceItem-module__sub-sources-container--l6N_4","subSourcesContainer":"SourceItem-module__sub-sources-container--l6N_4"};